import React, {useState} from 'react';
import './style.css';
import { HTMLHint } from 'htmlhint';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ContentHeading from '../../components/contentHeading/contentHeading';
import ContentHeadingButton from '../../components/contentHeading/contentHeadingButton';
import { AuthFetch } from '../../components/authFetch/authFetch';
import { Throbber } from '../../components/throbber/throbber'
import { ToggleBar } from '../../components/toggleBar/toggleBar';

const CampaignCreate = () => {
    const [htmlContent, setHtmlContent] = useState(`<!DOCTYPE html>
<html>
<body>

    <p>Hey there!</p>
    <p>This is a <b>sample email template.</b>
    You can customize it as needed.</p>


    <p>Best regards,</p>
    <p>Your Company</p>
</body>
</html>`);

    const [validationResults, setValidationResults] = useState('');
    const [isBlocking, setIsBlocking] = useState(false);

    const navigate = useNavigate();

    const [sendOption, setSendOption] = useState('sendNow');
    const [scheduleDate, setScheduleDate] = useState(new Date());

    const [showStatusMessage, setShowStatusMessage] = useState(false);
    const [statusState, setStatusState] = useState('');
    const [formData, setFormData] = useState(null);

    const handleGoBack = () => {
        navigate('/');
    };

    const isBlockingError = (messages) => {
        // Define what constitutes a blocking error, excluding empty tag errors
        console.log(messages)
        return messages.some(msg => msg.type === 'error' && !msg.message.includes('must not be empty'));
    };

    const validateHtml = (html) => {
        const messages = HTMLHint.verify(html);
        const blocking = isBlockingError(messages);
        return {
            messages: messages.map(msg => `${msg.line}:${msg.col} ${msg.message}`),
            blocking
        };
    };

    const handleHtmlChange = (e) => {
        const html = e.target.value;
        setHtmlContent(html);
        const { messages, blocking } = validateHtml(html);
        setValidationResults(messages.join('\n'));
        setIsBlocking(blocking);
    };

    const handleSendOptionChange = (e) => {
        setSendOption(e.target.value);
    };

    const segmentOptions = [
        {"label": "tribemails-dev -- All Users", "value": "5b0523e7090a4fae9442587f77356c22"},
        {"label": "tribemails-demo -- All Users", "value": "68a582290ab34f3e9d7ec2fb39f5baa7"},
        {"label": "Washington Bros", "value": "efe029a6054f4996afe9710e942817c8"},
        // {"label": "Vasuar -- All Users", "value": "3bab2c70e498483e9ab6649f7be73b5e"}
    ];

    const handleSubmit = (e) => {
        // Example logic for form submission
        e.preventDefault();
        const isFormValid = true; // Replace with actual validation logic; we have fields required, can add better value validation later
        if (isFormValid) {
            const formData = {
                name: document.querySelector("input[name='campaign-name']").value,
                subject: document.querySelector("input[name='subject']").value,
                sender_name: document.querySelector("input[name='sender-name']").value,
                sender_email: document.querySelector("input[name='sender-email']").value,
                segment_id: document.querySelector("select[name='segment-group']").value,
                html_contents: htmlContent,  // ✅ Directly from state
                send_options: sendOption == 'schedule' ? "Scheduled": "Immediate",
                scheduled_time: sendOption === 'schedule' ? scheduleDate.toISOString() : null  // ✅ Convert to ISO for backend
            };
            console.log("✅ Submitting Campaign Data:", formData);
            setFormData(formData);  // ✅ Store the form data in state
            sessionStorage.removeItem("fetch_/campaign");
            setStatusState('loading')
        } else {
            setStatusState('error');
        }
    };

    return (
        <div className='campaign-container'>

            <ContentHeading action={
                 <ContentHeadingButton handleContentHeadingButton={handleGoBack} buttonStyleClass="back-button" buttonName="Go Back" />
            } heading="Create New Campaign" />

            <div className='campaign-step step-large'> 
                <div className='email-details'>
                    <h2>Email Message</h2>
                    <form onSubmit={handleSubmit} >
                        <div className="form-group">
                            <label>Campaign Name</label>
                            <input type="text" name="campaign-name" placeholder="Enter campaign name" required />
                        </div>  
                        <div className="form-group">
                            <label>Subject line *</label>
                            <input type="text" name="subject" placeholder="Enter subject line" required />
                        </div>
                        <div className="form-group">
                            <label>Sender name *</label>
                            <input type="text" name="sender-name" placeholder="Enter sender name" required />
                        </div>
                        <div className="form-group">
                            <label>Sender email *</label>
                            <input type="email" name="sender-email" placeholder="Enter sender email" required />
                        </div>
                        <div className="form-group">
                            <label>Segment *</label>
                            <ToggleBar formName="segment-group" options={segmentOptions} />
                        </div>
                        <div className="form-group">
                            <label>Paste Template</label>
                            <textarea 
                                name="email-template"
                                placeholder="Paste your HTML template here"
                                onChange={handleHtmlChange}
                                value={htmlContent}
                                required
                            ></textarea>
                        </div>
                        <div className="form-group">
                            <label>Send Options</label>
                            <div className="send-options">
                                <div className="option-card">
                                    <input 
                                        type="radio" 
                                        id="schedule" 
                                        name="sendOption" 
                                        value="schedule" 
                                        checked={sendOption === 'schedule'} 
                                        onChange={handleSendOptionChange} 
                                    />
                                    <label htmlFor="schedule">
                                        <div className="option-icon">📅</div>
                                        <div className="option-text">
                                            <strong>Schedule</strong>
                                            <p>Choose a future date and time to send</p>
                                        </div>
                                    </label>
                                    {sendOption === 'schedule' && (
                                        <div className="form-group date-time">
                                            <DatePicker
                                                selected={scheduleDate}
                                                onChange={(date) => setScheduleDate(date)}
                                                showTimeSelect
                                                dateFormat="Pp"
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="option-card">
                                    <input 
                                        type="radio" 
                                        id="sendNow" 
                                        name="sendOption" 
                                        value="sendNow" 
                                        checked={sendOption === 'sendNow'} 
                                        onChange={handleSendOptionChange} 
                                    />
                                    <label htmlFor="sendNow">
                                        <div className="option-icon">🚀</div>
                                        <div className="option-text">
                                            <strong>Send Now</strong>
                                            <p>Start sending your campaign immediately</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="submit-container">
                            <button 
                                type="submit" 
                                className="submit-email-details" 
                                disabled={statusState === 'success'}
                            >
                                Submit
                            </button>
                            <div className={`status-message ${statusState}`}>
                                {statusState === 'success' && "Success! 🎉"}
                                {statusState === 'error' && "Error- Please fix errors."}
                                {statusState == 'loading' && <div class="throbber-wrapper"><Throbber /></div>}
                            </div>
                        </div>
                    </form>
                </div>

                <div className='email-preview'>
                    <h2 style={{paddingLeft: '20px'}}>Email Preview</h2>
                    {isBlocking && (
                        <pre className="validation-results" style={{color: 'red'}}>{validationResults}</pre>
                    )}
                    {!isBlocking && (
                        <iframe
                            srcDoc={htmlContent}
                            title="HTML Preview"
                            className="html-preview-iframe"
                        />
                    )}
                </div>

                {/* ✅ AuthFetch sends data once formData is set */}
                {formData && (
                    <AuthFetch 
                        apiMethod="POST"
                        endpoint="/campaign"
                        body={formData}
                        onDataLoaded={(response) => {
                            console.log("✅ Campaign Created:", response);
                            setStatusState('success');
                        }}
                        onErrorResponse={(response) => {
                            console.log("Error creating campaign");
                            setStatusState('error');
                        }}
                    />
                )}

            </div>
        </div>
    );
};

export { CampaignCreate };

